import { useEffect, useState, useRef } from "react";
import { React } from "react-router-dom";

export default function FlashCards({ position, onSelection, name})
{
  const cardRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [selected, setSelected] = useState(false);
  const [cssClass, setCSSClass] = useState(['card']);
  const [cssStyle, setCSStyle] = useState({});

  useEffect(() => {
  }, []);

  useEffect(() => {
    updateCSSClass();
    if (selected)
      onSelection(name);
  }, [hovered, selected]);

  useEffect(() => {
    updateCSStyle();
  }, [position]);

  const hMouseEnter = () => { setHovered(true); }
  const hMouseLeave = () => { setHovered(false); setSelected(false); }

  const hMouseDown = () => {if (hovered) setSelected(true); }
  const hMouseUp = () => { setSelected(false); }

  function updateCSSClass() {
    let output = "card";
    output += hovered ? " hover" : "";
    output += selected ? " selected" : "";
    setCSSClass(output);
  }

  function updateCSStyle()
  {
    if (selected)
    {
      setCSStyle({
      left: position.x - cardRef.current.offsetWidth/2, 
      top: position.y - cardRef.current.offsetHeight/2});
    }
  }

  return (
    <div ref={cardRef}
    style={cssStyle} /*TODO: magic number to rem*/
    onMouseEnter={hMouseEnter} 
    onMouseLeave={hMouseLeave} 
    onMouseDown={hMouseDown} 
    onMouseUp={hMouseUp} 
    className={cssClass}>
      Hello
    </div>
  );
}